import React, { useEffect, useRef, useState } from 'react'

interface CcChipsEditorProps {
  value: string[]
  onChange: (next: string[]) => void
  disabled: boolean
}

const EMAIL_PATTERN = /.+@.+\..+/

export const CcChipsEditor: React.FunctionComponent<CcChipsEditorProps> = (props) => {
  const { value, onChange, disabled } = props
  const [editing, setEditing] = useState(false)
  const [draft, setDraft] = useState('')
  const inputRef = useRef<HTMLInputElement | null>(null)

  useEffect(() => {
    if (editing) inputRef.current?.focus()
  }, [editing])

  function commit(): void {
    const trimmed = draft.trim()
    if (trimmed && EMAIL_PATTERN.test(trimmed) && !value.includes(trimmed)) {
      onChange([...value, trimmed])
    }
    setDraft('')
    setEditing(false)
  }

  return (
    <div
      className="recurring-content cc-chips"
      style={{
        flexWrap: 'wrap',
        overflowX: 'visible',
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
      }}
    >
      {value.map((email) => (
        <span className="chip" key={email}>
          {email}{' '}
          <span
            className="chip-remove"
            onClick={() => onChange(value.filter((entry) => entry !== email))}
          >
            ×
          </span>
        </span>
      ))}
      {editing ? (
        <input
          ref={inputRef}
          className="form-input"
          type="email"
          placeholder="email@company.com"
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
          onBlur={commit}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault()
              commit()
            } else if (event.key === 'Escape') {
              setDraft('')
              setEditing(false)
            }
          }}
        />
      ) : (
        <button
          type="button"
          className="chip-add"
          title="Add CC email"
          onClick={() => setEditing(true)}
        >
          +
        </button>
      )}
    </div>
  )
}
